export function initDocumentCards() {
  const cards = document.querySelectorAll(".documents__card");

  cards.length &&
    cards.forEach((card) => {
      const downloadButton = card.querySelector(".documents__card-button");

      downloadButton.addEventListener("click", function (event) {
        event.stopPropagation();
      });

      card.addEventListener("click", function () {
        window.open(this.dataset.url, "_blank");
      });
    });
}
